import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';

import { AppComponent } from './app.component';
import { MainComponent } from './pages/main/main.component';
import { JogoDaVelhaComponent } from './pages/jogo-da-velha/jogo-da-velha.component';
import { FooterComponent } from './pages/footer/footer.component';


@NgModule({
  declarations: [
    AppComponent,
    MainComponent,
    JogoDaVelhaComponent,
    FooterComponent
  ],
  imports: [
    BrowserModule,
    BrowserModule,
    FormsModule
  ],
  providers: [],
  bootstrap: [AppComponent]
})

export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts